import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getNewsByFilter } from "../api/apiHandler";
import { getMediaBaseUrl } from "../utils/backendUrl";

const LatestStories = () => {
  const { t } = useTranslation();
  const [latestNews, setLatestNews] = useState([]);

  const BASE_URL = getMediaBaseUrl();

  const mapProductToCard = (item) => {
    let imageUrl = "";
    if (item.thumbnail) {
      if (item.thumbnail.startsWith("http")) {
        imageUrl = item.thumbnail;
      } else if (item.thumbnail.startsWith("/images/")) {
        imageUrl = item.thumbnail;
      } else {
        imageUrl = `${BASE_URL}/uploads/news/${encodeURIComponent(item.thumbnail)}`;
      }
    }

    return {
      id: item.id,
      image: imageUrl,
      title: item.news_title || item.title || "",
      category: item.category || "",
    };
  };

  useEffect(() => {
    let isMounted = true;
    const loadLatestNews = async () => {
      try {
        const res = await getNewsByFilter({ limit: 6 });
        const items = Array.isArray(res?.data) ? res.data : [];
        if (isMounted) {
          setLatestNews(items.map(mapProductToCard));
        }
      } catch (err) {
        console.error("Error fetching latest news:", err);
      }
    };
    loadLatestNews();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-white border-gray-200 rounded-lg border shadow-sm ">
      {/* HEADER */}
      <div className="px-4 py-3 bg-brand-red border-b border-brand-red rounded-t-lg">
        <h3 className="font-bold text-white text-[18px] uppercase tracking-wide">
          {t('widgets.latest_stories')}
        </h3>
      </div>

      {/* STORIES */}
      <div>
        {latestNews.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="flex gap-3 p-2 hover:bg-gray-50 transition group border-b border-gray-100 last:border-0"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-20 h-14 object-cover rounded"
            />

            <div className="flex-1 min-w-0 flex flex-col justify-center">
              <p className="text-sm text-gray-900 font-medium leading-snug truncate group-hover:text-brand-red">
                {item.title}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default LatestStories;
